import React from "react";
import {useTranslation} from "react-i18next";

import {SelectField, FilterLabel} from "./FilterComponentStyles";

const WeekFilter = ({
    value,
    onChange,
    disabled = false,
    mode = undefined,
    showAllOption = true,
    allowClear = false,
    showSearch = false,
    hideTitle = false,
    selectMarginBottom = "20px",
    ...props
}) => {
    const {t} = useTranslation();

    return (
        <React.Fragment>
            {!hideTitle && <FilterLabel>{t("fields.week", {ns: "common"})}</FilterLabel>}
            <SelectField
                data-testid="weekSelect"
                value={value}
                onChange={onChange}
                disabled={disabled}
                mode={mode}
                allowClear={allowClear}
                showSearch={showSearch}
                mb={selectMarginBottom}
                {...props}
            >
                {[...Array(52)].map((_, index) => (
                    <SelectField.Option
                        key={index}
                        value={index + 1}
                        data-testid="weekSelect_option"
                    >
                        {index + 1}. Hafta
                    </SelectField.Option>
                ))}
            </SelectField>
        </React.Fragment>
    );
};

export default WeekFilter;
